import React from 'react'

import IntegrationAuthenticationSegment from 'components/IntegrationAuthenticationSegment'
import useAxios, { mutate } from 'hooks/useAxios'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import { oauthDomain } from 'domains/authentication/oauth'
import { toast } from 'libs/toast'
import constants from 'config/constants'
import useWorkspace from 'hooks/useWorkspace'

/**
 *
 * @param {object} props
 * @param {boolean} props.isAuthenticated
 */
export default function IntercomAuthentication({ isAuthenticated }) {
  const saveUserActivityLog = useSaveUserActivityLog()
  const workspaceToken = useWorkspace()

  const { fetch: revokeAccess, loading: revoking } = useAxios({
    method: 'delete',
    url: 'intercom/authentication/',
    skip: true,
  })

  function authenticate() {
    const nonce = oauthDomain.generateNonce({
      redirectPathname: location.pathname,
      serviceName: 'Intercom',
      workspaceToken: workspaceToken,
    })
    window.location.href = `https://app.intercom.com/oauth?client_id=${constants.intercomAppClientId}&state=${nonce}&redirect_uri=${window.location.origin}/oauth/intercom/`
  }

  function handleRevokeAccess() {
    const action = ACTION_NAME.revoke_intercom_credential

    revokeAccess()
      .then(() => {
        mutate('intercom/authentication/', null)
        toast.success("You've successfully revoked access with Intercom.")
        saveUserActivityLog({
          action,
          target: 'intercom_credential',
          requestBody: {},
          statusCode: 200,
        })
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        saveUserActivityLog({
          action,
          target: 'intercom_credential',
          requestBody: {},
          statusCode: error.status,
        })
      })
  }

  return (
    <IntegrationAuthenticationSegment
      isAuthenticated={isAuthenticated}
      loading={revoking}
      name="Intercom"
      onActivate={authenticate}
      onDeactivate={handleRevokeAccess}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomAuthentication/index.js